import { render, staticRenderFns } from "./PublicChallenges.vue?vue&type=template&id=1b6f75e6&scoped=true"
import script from "./PublicChallenges.vue?vue&type=script&lang=js"
export * from "./PublicChallenges.vue?vue&type=script&lang=js"
import style0 from "./PublicChallenges.vue?vue&type=style&index=0&id=1b6f75e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f75e6",
  null
  
)

export default component.exports